import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="fetch-logo"

export default class extends Controller {
  static targets = ["link", "image", "file"];

  async fetch() {
    const url = this.linkTarget.value.trim();
    if (!url) return;

    const csrfToken = document.querySelector("meta[name='csrf-token']").content;

    try {
      const response = await fetch("/app/fetch_logo", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
        },
        body: JSON.stringify({ url }),
      });

      if (!response.ok) throw new Error("Failed to fetch logo");

      // Get the binary image data
      const blob = await response.blob();

      // Create an object URL for the image
      const objectURL = URL.createObjectURL(blob);

      // Update the image tag
      this.imageTarget.src = objectURL;

      // Update the file input with the fetched image
      const file = new File([blob], "logo.png", { type: blob.type });
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      this.fileTarget.files = dataTransfer.files;
    } catch (error) {
      console.error("Error fetching logo:", error);
    }
  }
}